import React from "react";
import PropTypes from "prop-types";

import Rule from "@components/Rule";

import { css } from "@oddcommon/utils";
import styles from "./CreditsSection.module.scss";

export default function FreeformSection({
  description,
  projects,

  className,
  ...props
}) {
  const nameListItem = (n, i, { length }) => (
    <React.Fragment key={i}>
      <nobr>{n}</nobr>
      {i < length - 1 && ", "}
    </React.Fragment>
  );

  return (
    <section className={css(styles.base, className)} {...props}>
      <header>
        <Rule className={styles.rule}>Props where props are due</Rule>
        <h2>Credits</h2>
      </header>

      <div className={styles.description}>{description}</div>

      <div className={styles.creditsBlock}>
        {projects.map(({ name: projectName, credits }, i) => (
          <div className={styles.project} key={i}>
            <h6>{projectName}</h6>
            <ul className={styles.credits}>
              {credits.map(({ credit, name }, i) => (
                <li key={i}>
                  <figure>
                    <figcaption>{credit}</figcaption>
                    {!Array.isArray(name) ? name : name.map(nameListItem)}
                  </figure>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

FreeformSection.propTypes = {
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.node.isRequired,
      credits: PropTypes.arrayOf(
        PropTypes.shape({
          credit: PropTypes.node.isRequired,
          name: PropTypes.node.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};
